import { AxiosInstance } from 'axios';
import { PartnerOrMaster } from 'types/partner';
import { Result } from 'services/Result';

export class PartnersService {
  private axiosInstance: AxiosInstance;
  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getPartners = async () => {
    const response = await this.axiosInstance.get<Result<PartnerOrMaster[]>>(`api/partners`);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while fetching partners.');
  };
}

export default PartnersService;
